import { PaginationRequest } from '@repo/ui/data-table'

import { Files } from '../../lib/constants/files'
import { CenterEventAction } from '../../lib/types/models/center-event-action/center-event-action'
import { CenterEventActionInput } from '../../lib/types/models/center-event-action/center-event-action-input'
import { FileInput } from '../../lib/types/models/file/file-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type CenterEventActionRequest = {
  centerEventId: number
  data: CenterEventActionInput
  input?: PaginationRequest
}

export const createCenterEventAction = async (
  req: CenterEventActionRequest
): Promise<CenterEventAction> => {
  const { centerEventId, input, data } = req
  if (data.files?.length) {
    const uploadedFiles = await Promise.all(
      data.files.map((file) => (file ? uploadFile(Files.CENTER_EVENT_ACTION, file) : null))
    )

    data.files = uploadedFiles.filter((file): file is FileInput => file != null)
  }
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centerEvents.createCenterEventAction.url, {
          id: centerEventId
        }),
        input
      )
    )
    .post<CenterEventAction, CenterEventActionInput>(data)
}
